/* eslint-disable jsx-a11y/alt-text */
// @flow
import React, {
  useEffect, useRef, useState, useMemo
} from 'react';
import type { Element } from 'react';
import LazyLoad from 'react-lazyload';
import Input from '@components/Input';
import { createCandidate, resetCandidateCreate } from '@redux/components/CandidateCreate/actions';
import TagManager from 'react-gtm-module';
import { DATA_LAYER_NAME } from '@lib/constants';
import { NextSeo } from 'next-seo';
import { phone } from 'phone';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import ProgressBar from '@components/ContributionCard/ProgressBar';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import type { Doctors } from '@screens/Finder/Doctor/types';

import { connect } from 'react-redux';

import compose from 'lodash/fp/compose';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Pagination, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

import { withFormik } from '@lib';

import {
  withTranslation, Trans, Link, nextRoutes
} from '@i18n';
import { useBreakpoint } from '@lib/hooks/useBreakpoint';

import type { GlobalState } from '@globalTypes';
import FAQQUESTIONEXPAND from '@components/FAQQuesExpand/index';
import { getInternationalPhone } from '@services/phone';

import {
  StyledVerticalSpacer,
  StyledPageCover,
  StyledFormUnit,
  StyledMiniVerticalSpacer,
} from '@components/Wrappers/styles/index';

import InputPhone from '@components/InputPhone/index';
import DocumentsUploadNew from '@screens/Profile/ProfileDocuments/DocumentsUploadNew/index';
import { requestDoctorList, resetDoctorList } from '@screens/Finder/Doctor/redux/actions';
import SearchResultListItem from '@screens/Finder/Doctor/SearchResultList/SearchResultListItem/index';
import PackageSearchResultListItem from '@screens/Finder/Package/SearchResultList/SearchResultListItem/index';
import waitForPageReady from '@lib/waitForPageReady';
import { PhoneCode } from '@components/ContactPageNew/countryCode';
import { requestFacilityList, resetFacilityList } from '@screens/Finder/Facility/redux/actions';
import ArticleCard from '@screens/Blog/Article/components/RelatedPostCard/articleCard';

import theme from '@lib/theme';
import { requestPackageList } from '@screens/Finder/Package/redux/actions';
import {
  requestBlogArticles,
  resetBlogArticles
} from '@screens/Blog/redux/actions';
import { calculateGridUnitSize } from '@lib/helpers';
import GridCarousel from '@components/GridCarousel/index';
import { Loader } from '@components/OnPageLoader/index';
import Checkbox from '@components/Checkbox';
import {
  FINDER_DOCTOR, YAPITA_HEALTH_URL, CUREFY_URL, DETAILS_TREATMENT
} from '@routes';
import ItemsCarousel from 'react-items-carousel';
import {
  StyledInput,
  StyledGrid,
  StyledGridUnit,
  IconImage,
  StyledLabel,
  StyledCoverMaxWidthNoBottomMargin,
  StyledBannerTag,
  StyledFormHeadline,
  StyledBannerLeft,
  StyledFormRow,
  StyledSubmitButton,
  MainSubHealine,
  TagsTextContent,
  StyledForWhyGrid,
  DocumentsWrapper,
  StyledSeeMore,
  StyledFlexCenter,
  StyledCompletedIcon,
  StyledMiniPhone,
  StyledMiniWhatsapp,
  ContactImmediatelyHeadline,
  FormWrapper,
  MetaTags,
  BannerTopHeadline,
  StyledBannerTagsWrapper,
  StyledTagsImageWrapper,
  StyledScreenWrapper,
  StyledFastField,
  StyledItem,
  TermsAndConditionsWrapper,
  StyledLabelTextWrapper,
  StyledCategoryBody,
  StyledCategory,
  StyledLinks,
  StyledRelatedPagesDesktop,
  StyledRealtedPagesDiv,
  ContentBlock,
  StyledTagLine,
  ContentBlockHeading,
  StyledContent,
  StyledContentImage,
  StyledContentText,
  StyledRelatedPageHeading,
  StyledInformation,
  StyledTestimonials,
  StyledTestimonialImages,
  TestimonialImages,
  StyledGridWhyYapita,
  StyledWhyElement,
  StyledWhyBlock,
  StyledWhyImage,
  StyledWhyText,
  StyledCaretDown,
  StyledCategoryHeading,
  StyledCaretUp,
  StyledVariant,
  StyledImage,
  StyledVariantLink,
  StyledValidationMessage,
  StyledLoading,
  StyledCardsMaxWidth,
  StyledSwiper
} from './styles';

import { requestTreatmentDetails, resetTreatmentDetails } from './redux/actions';
import type { Props, Treatment, DynamicMetaData } from './types';
import DoctorVariantList from './components/Variants/DoctorCard/index';
import { StyledDoctorvariantMainHeadline } from './components/Variants/styles';
import HospitalVariantList from './components/Variants/HospitalCard/index';
import CostVariant from './components/Variants/Cost/index';

SwiperCore.use([Navigation, Pagination]);

const TreatmentDetails = ({
  t,
  resetTreatmentDetails,
  treatmentDetails,
  setFieldValue,
  values,
  errors,
  createCandidate,
  requestDoctorList,
  resetDoctorList,
  requestPackageList,
  created,
  packages,
  resetCandidateCreate,
  doctorFinder,
  isPackageRequesting,
  resetFacilityList,
  facilityData,
  curefyDomain,
  requestBlogArticles,
  resetBlogArticles,
  blogs
}: Props): Element<any> => {
  const { locale } = nextRoutes;


  const formRef = useRef(null);
  useEffect((): Function => {
    fetch('https://ipapi.co/json')
      .then(res => res.json())
      .then((response) => {
        // eslint-disable-next-line no-unused-expressions
        response.city && setFieldValue('address_city', response.city || '');
        const internationalPhone: string = getInternationalPhone(
          PhoneCode[response.country_code],
          ''
        );
        // eslint-disable-next-line no-unused-expressions
        response.country_code && setFieldValue('phone', internationalPhone || '');
        // eslint-disable-next-line no-unused-expressions
        response.country_name && setFieldValue('country', response.country_name || '');
      })
      .catch(() => {});

    resetCandidateCreate();

    return () => {
      resetTreatmentDetails();
      resetCandidateCreate();
      resetDoctorList();
      resetBlogArticles();
    };
  }, []);

  const treatment: ?Treatment = treatmentDetails?.data;
  const qualification = treatment?.attributes?.description;
  const packageHeadline = treatment?.attributes?.package_headline;
  const packageDetails = treatment?.attributes?.package_details;
  const featuredImage = treatment?.attributes?.featured_image_url;
  const featuredImgAlt = treatment?.attributes?.featured_alt_tag;
  const Costsummary = treatment?.attributes?.summary;
  const variantsList = treatment?.variantDetails[0] || [];
  const blogList = (blogs || []);
  // const slicedBlogs = blogList.slice(0, 8);
  const testimonialList = treatment?.treatmentImages;
  const testimonials = testimonialList ? testimonialList.filter(tp => tp.attributes.kind === 'testimonials') : [];
  const costVariantList = variantsList.filter(variant => variant[0]?.attributes?.category === 'cost');
  const destinationVariantList = variantsList.filter(variant => variant[0]?.attributes?.category === 'destination');
  const doctorVariantList = variantsList.filter(variant => variant[0]?.attributes?.category === 'doctors');
  const hospitalVariantList = variantsList.filter(variant => variant[0]?.attributes?.category === 'hospitals');
  const styledblock1 = (costVariantList.length || destinationVariantList.length);
  const styledblock2 = (hospitalVariantList.length || doctorVariantList.length);
  const {
    name,
    tagline,
    department,
    key_features,
    canonical_tag,
    meta_description,
    is_published,
    meta_keywords,
    meta_title,
    slug,
    seo_image,
    category,
    parent_name,
    parent_id,
    variant_min_cost,
    variant_max_cost,
    variant_average_cost
  } = treatment?.attributes || {};
  const treatment_id = treatment?.id;
  const [doctorsSlide, setDoctorsSlide] = React.useState(0);
  const [packageSlide, setPackageSlide] = React.useState(0);
  useEffect(() => {
    if (created) {
      trackCreated(slug);
    }
  }, [created]);

  const { faqs } = treatment || {};

  const isMobile = useBreakpoint('mobile', 'tablet');
  const isTablet = useBreakpoint('tablet', 'desktop');
  // eslint-disable-next-line no-nested-ternary
  const onScreenCount = isMobile ? 2 : isTablet ? 3 : 4;
  const onScreenCountPackages = isMobile ? 1 : 3;
  const title = name;

  const doctors: Doctors = doctorFinder.data || [];
  const isDoctorRequesting = doctorFinder.getStatus.requesting;

  const isDefault = category === 'default';
  const isCostVariant = category === 'cost';
  const isHospitalVariant = category === 'hospitals';
  const isDoctorVariant = category === 'doctors';
  const isDestinationVariant = category === 'destination';

  const [Block1, setBlock1] = useState(costVariantList.length !== 0 ? 'cost' : 'destination');
  const [Block2, setBlock2] = useState(hospitalVariantList.length !== 0 ? 'hospital' : 'doctors');
  const [MobileBlock, setMobileBlock] = useState('cost');
  const [pageUrl, setPageUrl] = useState('');

  if (typeof window !== 'undefined' && pageUrl === '') {
    setPageUrl(window.location.href);
  }

  const trackCreated = async (treatmentPage) => {
    const { default: ReactPixel } = await import('react-facebook-pixel');
    ReactPixel.init('370952911555724');
    ReactPixel.trackCustom('LeadCreated');
    TagManager.dataLayer({
      dataLayerName: DATA_LAYER_NAME,
      dataLayer: {
        event: 'PatientCreated',
        treatmentPage
      }
    });
  };

  useEffect((): Function => {
    fetch('https://ipapi.co/json')
      .then(res => res.json())
      .then((response) => {
        // eslint-disable-next-line no-unused-expressions
        response.city && setFieldValue('address_city', response.city || '');
        const internationalPhone: string = getInternationalPhone(
          PhoneCode[response.country_code],
          ''
        );
        // eslint-disable-next-line no-unused-expressions
        response.country_code && setFieldValue('phone', internationalPhone || '');
        // eslint-disable-next-line no-unused-expressions
        response.country_name && setFieldValue('country', response.country_name || '');
      })
      .catch(() => {});

    requestPackageList({ treatment_id: isDefault ? treatment_id : parent_id });
    requestBlogArticles({ department: department || '' });
    if (!isDoctorVariant) {
      requestDoctorList({ department, dontScroll: true, custom_per_page: 10 });
    }

    resetCandidateCreate();

    return () => {
      resetTreatmentDetails();
      resetCandidateCreate();
      resetFacilityList();
      resetDoctorList();
      resetBlogArticles();
    };
  }, []);

  const keyFeatures = useMemo(() => (key_features || '').split('\n'), [key_features]);
  const LazyLoadOnMobile = isMobile ? LazyLoad : React.Fragment;
  const lazyLoadProps = isMobile ? { height: 0, offset: 5000, once: true } : {};

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setFieldValue('phone', formattedValue);
    if (data.countryCode) {
      setFieldValue('phone_code', data.countryCode.toUpperCase());
    }

    if (!values.country) {
      setFieldValue('country', data.name);
    }
  };


  const handleSubmit = () => {
    createCandidate({ ...values });
  };

  const BannerTag = tag => (
    <StyledBannerTag>
      <IconImage>
        <LazyLoadImage src="../../../../static/images/svg/TreatmentPageTick.svg" alt="img" />
      </IconImage>
      <TagsTextContent textcolor="#093C59">{tag}</TagsTextContent>
    </StyledBannerTag>
  );

  const metaData: DynamicMetaData = t('Seo:TreatmentSeo', {
    returnObjects: true,
    name
  });

  const metaTagIspublished = !is_published
    ? [
      {
        name: 'robots',
        content: 'noindex'
      }
    ]
    : [];

  const updatedCanonicalTag = curefyDomain && canonical_tag ? canonical_tag.replace('yapitahealth.com', 'curefy.ai') : canonical_tag;
  const [intervalPackageId, setPackageIntervalId] = React.useState(null);
  const color = '#5FA6BF';
  const handlePackageTimeInterval = () => {
    clearInterval(intervalPackageId);
    const newId = setInterval(() => {
      setPackageSlide((x) => {
        if (x > (packages || []).slice(0, 8).length) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setPackageIntervalId(newId);
  };
  const [intervalDoctorId, setDoctorIntervalId] = React.useState(null);
  const handleDoctorTimeInterval = () => {
    clearInterval(intervalDoctorId);
    const newId = setInterval(() => {
      setDoctorsSlide((x) => {
        if (x > (packages || []).slice(0, 8).length - 1) {
          return 0;
        }
        return x + 1;
      });
    }, 4000);

    setDoctorIntervalId(newId);
  };

  const showLoop = isMobile ? blogList.length >= 2 : blogList.length >= 4;

  return (
    <StyledScreenWrapper>
      <NextSeo
        title={`${meta_title || tagline || metaData.MetaTitle} - ${curefyDomain ? 'Curefy' : 'Yapita Health'}`}
        description={meta_description || metaData.MetaDescription}
        canonical={updatedCanonicalTag || `${curefyDomain ? CUREFY_URL : YAPITA_HEALTH_URL}/${locale}/treatments/${slug}`}
        openGraph={{
          url: pageUrl,
          title: meta_title || metaData.MetaTitle,
          description: meta_description || metaData.MetaDescription,
          images: [
            {
              url:
                seo_image?.url
                || 'https://yapita-production.s3.ap-south-1.amazonaws.com/images/yapita-health-og.jpg',
              width: 800,
              height: 600,
              alt: 'Yapita Health - Your Medical Partner',
              type: 'image/jpg'
            }
          ],
          siteName: curefyDomain ? 'Curefy' : 'Yapita Health'
        }}
        metaTags={metaTagIspublished}
        twitter={{
          handle: '@yapitahealth',
          site: '@yapitahealth',
          cardType: 'summary_large_image'
        }}
      />
      {meta_keywords && <MetaTags name="meta-keywords" content={meta_keywords} />}
      <>
        <StyledPageCover bgcolor={theme.gradients.BannerGradientCostPage}>
          <StyledCoverMaxWidthNoBottomMargin>
            {!isDefault && !isCostVariant && !isDestinationVariant && (
              <StyledDoctorvariantMainHeadline textcolor>{name}</StyledDoctorvariantMainHeadline>
            )}
          </StyledCoverMaxWidthNoBottomMargin>
        </StyledPageCover>
        {isDoctorVariant && <DoctorVariantList Doctors={doctors} isMobile={isMobile} />}
        {isHospitalVariant && <HospitalVariantList Hospitals={facilityData} isMobile={isMobile} />}
        {!isDoctorVariant && !isHospitalVariant && (
          <StyledPageCover bgcolor="#F0FFFD">
            {isCostVariant && (
              <StyledDoctorvariantMainHeadline>{name}</StyledDoctorvariantMainHeadline>
            )}
            <StyledCoverMaxWidthNoBottomMargin>
              <StyledGrid>
                {!isCostVariant ? (
                  <StyledGridUnit size={{ mobile: 1, desktop: 2 / 3 }}>
                    <StyledBannerLeft>
                      {
                        !isDestinationVariant ? (
                          <BannerTopHeadline textcolor="#093C59">
                            {t('DetailsJob:MainHeadlineStatic', {
                              title: isDefault ? title : parent_name || ''
                            })}
                          </BannerTopHeadline>
                        )
                          : (
                            <BannerTopHeadline textcolor="#093C59">
                              {name}
                            </BannerTopHeadline>
                          )
                      }
                      <StyledTagsImageWrapper>
                        {key_features && (
                          <StyledBannerTagsWrapper>
                            <StyledVerticalSpacer>
                              {keyFeatures.map(tag => BannerTag(tag))}
                            </StyledVerticalSpacer>
                          </StyledBannerTagsWrapper>
                        )}
                        {!key_features && (
                          <StyledBannerTagsWrapper>
                            <StyledVerticalSpacer>
                              {(t('DetailsJob:Features', { returnObjects: true })).map(tag =>
                                BannerTag(tag))}
                            </StyledVerticalSpacer>
                          </StyledBannerTagsWrapper>
                        )}
                        <StyledTagLine>
                          {tagline}
                        </StyledTagLine>
                      </StyledTagsImageWrapper>
                    </StyledBannerLeft>
                  </StyledGridUnit>
                ) : (
                  <CostVariant
                    size={{ mobile: 1, desktop: 2 / 3 }}
                    min_cost={variant_min_cost}
                    max_cost={variant_max_cost}
                    average_cost={variant_average_cost}
                  />
                )}

                <FormWrapper size={{ mobile: 1, desktop: 1 / 3 }}>
                  <StyledFormHeadline ref={formRef}>
                    {t('DetailsJob:FormHeadline')}
                  </StyledFormHeadline>
                  {!created ? (
                    <CostPageForm
                      t={t}
                      phonefunction={phone}
                      createCandidate={createCandidate}
                      values={values}
                      errors={errors}
                      handlePhoneChange={handlePhoneChange}
                      handleSubmit={handleSubmit}
                    />
                  ) : (
                    <StyledLoading
                      icon={faSpinner}
                      size="4x"
                      loading
                    />
                  )}
                </FormWrapper>
              </StyledGrid>
            </StyledCoverMaxWidthNoBottomMargin>
          </StyledPageCover>
        )}
        <StyledPageCover>
          <StyledCoverMaxWidthNoBottomMargin>
            {(isDefault || isDestinationVariant || isCostVariant)
            && treatment?.attributes?.overview_headline
              ? (
                <StyledContent>
                  <StyledContentText>
                    <ContentBlockHeading>
                      {treatment?.attributes?.overview_headline}
                    </ContentBlockHeading>
                    <ContentBlock dangerouslySetInnerHTML={{ __html: qualification }} />
                  </StyledContentText>
                  <StyledImage>
                    <StyledContentImage src={featuredImage || (isDefault ? '../../../../static/images/finder/side-view-doctor.webp' : '../../../../static/images/finder/side-view-patient.webp')} alt={featuredImgAlt || 'altimg'} />
                  </StyledImage>
                </StyledContent>
              )
              : <></>}
          </StyledCoverMaxWidthNoBottomMargin>
        </StyledPageCover>

        {isCostVariant || isDestinationVariant
          ? (
            <StyledPageCover>
              <StyledCoverMaxWidthNoBottomMargin>
                <StyledInformation>
                  <StyledRelatedPageHeading>
                    {packageHeadline || ''}
                  </StyledRelatedPageHeading>
                  <ContentBlock dangerouslySetInnerHTML={{ __html: packageDetails }} />
                </StyledInformation>
              </StyledCoverMaxWidthNoBottomMargin>
            </StyledPageCover>
          )
          : <></>}


        <LazyLoadOnMobile {...lazyLoadProps}>
          <StyledCoverMaxWidthNoBottomMargin>
            <StyledVerticalSpacer>
              <StyledPageCover>
                <StyledForWhyGrid>
                  <StyledRelatedPageHeading>
                    {t('DetailsJob:WhyYapita')}
                  </StyledRelatedPageHeading>
                  <StyledGridWhyYapita>
                    <StyledWhyElement>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/Doctors.svg" alt="Doctors" />
                        <StyledWhyText>
                          {t('DetailsJob:Whydoctors')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/Packages.svg" alt="Packages" />
                        <StyledWhyText>
                          {t('DetailsJob:WhyPackages')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                    </StyledWhyElement>
                    <StyledWhyElement>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/Patient.svg" alt="Patient" />
                        <StyledWhyText>
                          {t('DetailsJob:WhyPatients')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/RoboticTreatment.svg" alt="RoboticTreatment" />
                        <StyledWhyText>
                          {t('DetailsJob:WhyTreatments')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                    </StyledWhyElement>
                    <StyledWhyElement>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/InvasiveSurgery.svg" alt="InvasiveSurgery" />
                        <StyledWhyText>
                          {t('DetailsJob:WhySurgery')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                      <StyledWhyBlock>
                        <StyledWhyImage src="../../../../static/images/svg/Countries.svg" alt="Countries" />
                        <StyledWhyText>
                          {t('DetailsJob:whyCountries')}
                        </StyledWhyText>
                      </StyledWhyBlock>
                    </StyledWhyElement>
                  </StyledGridWhyYapita>
                </StyledForWhyGrid>
              </StyledPageCover>
            </StyledVerticalSpacer>
          </StyledCoverMaxWidthNoBottomMargin>

          {isDefault
            ? (
              <StyledPageCover>
                <StyledCoverMaxWidthNoBottomMargin>
                  <StyledInformation>
                    <StyledRelatedPageHeading>
                      {packageHeadline || ''}
                    </StyledRelatedPageHeading>
                    <ContentBlock dangerouslySetInnerHTML={{ __html: packageDetails }} />
                  </StyledInformation>
                </StyledCoverMaxWidthNoBottomMargin>
              </StyledPageCover>
            )
            : <></>}

          {isCostVariant || isDestinationVariant
            ? (
              <StyledPageCover>
                <StyledCoverMaxWidthNoBottomMargin>
                  <StyledInformation>
                    <ContentBlock dangerouslySetInnerHTML={{ __html: Costsummary }} costsummary />
                  </StyledInformation>
                </StyledCoverMaxWidthNoBottomMargin>
              </StyledPageCover>
            )
            : <></>}
          {(variantsList || []).length !== 0
            ? (
              <StyledPageCover>
                <StyledCoverMaxWidthNoBottomMargin>
                  <StyledRelatedPageHeading>
                    {t('DetailsJob:RelatedPage', { name: isDefault ? title : parent_name || '' })}
                  </StyledRelatedPageHeading>
                  <StyledRelatedPagesDesktop>
                    <StyledRealtedPagesDiv hide={styledblock1}>
                      {costVariantList.length !== 0
                        ? (
                          <StyledCategoryBody Block1hide={Block1 !== 'cost'} MobileHide={MobileBlock === 'cost'}>
                            <StyledCategoryHeading
                              onClick={() => {
                                setBlock1(Block1 === 'cost' ? false : 'cost');
                                setMobileBlock(MobileBlock === 'cost' ? false : 'cost');
                              }}
                            >
                              <StyledCategory>{t('DetailsJob:CostTreatment')}</StyledCategory>
                              <StyledCaretDown
                                src="../../../../static/images/svg/CaretDown.svg"
                                Block1hide={Block1 === 'cost'}
                                MobileHide={MobileBlock === 'cost'}
                              />
                              <StyledCaretUp
                                src="../../../../static/images/svg/CaretUp.svg"
                                Block1hide={Block1 === 'cost'}
                                MobileHide={MobileBlock === 'cost'}
                              />
                            </StyledCategoryHeading>
                            <StyledLinks Block1hide={Block1 !== 'cost'} MobileHide={MobileBlock !== 'cost'}>
                              {
                              costVariantList.map(variant =>
                                (
                                  <StyledVariant>
                                    <Link
                                      passHref
                                      href={DETAILS_TREATMENT}
                                      params={{ slug: variant[0].attributes.slug }}
                                    >
                                      <StyledVariantLink target="_blank">
                                        {variant[0].attributes.name}
                                      </StyledVariantLink>
                                    </Link>
                                  </StyledVariant>
                                ))
                              }
                            </StyledLinks>
                          </StyledCategoryBody>
                        )
                        : <></>}
                      {destinationVariantList.length !== 0
                        ? (
                          <StyledCategoryBody Block1hide={Block1 !== 'destination'} MobileHide={MobileBlock === 'destination'}>
                            <StyledCategoryHeading
                              onClick={() => {
                                setBlock1(Block1 === 'destination' ? false : 'destination');
                                setMobileBlock(MobileBlock === 'destination' ? false : 'destination');
                              }}
                            >
                              <StyledCategory>{t('DetailsJob:Destination')}</StyledCategory>
                              <StyledCaretDown
                                src="../../../../static/images/svg/CaretDown.svg"
                                Block1hide={Block1 === 'destination'}
                                MobileHide={MobileBlock === 'destination'}
                              />
                              <StyledCaretUp
                                src="../../../../static/images/svg/CaretUp.svg"
                                Block1hide={Block1 === 'destination'}
                                MobileHide={MobileBlock === 'destination'}
                              />
                            </StyledCategoryHeading>
                            <StyledLinks Block1hide={Block1 !== 'destination'} MobileHide={MobileBlock !== 'destination'}>
                              {
                              destinationVariantList.map(variant => (
                                <StyledVariant>
                                  <Link
                                    passHref
                                    href={DETAILS_TREATMENT}
                                    params={{ slug: variant[0].attributes.slug }}
                                  >
                                    <StyledVariantLink target="_blank">
                                      {variant[0].attributes.name}
                                    </StyledVariantLink>
                                  </Link>
                                </StyledVariant>
                              ))
                               }
                            </StyledLinks>
                          </StyledCategoryBody>
                        ) : <></>}
                    </StyledRealtedPagesDiv>
                    <StyledRealtedPagesDiv hide={styledblock2}>
                      {hospitalVariantList.length !== 0
                        ? (
                          <StyledCategoryBody Block2hide={Block2 !== 'hospital'} MobileHide={MobileBlock === 'hospital'}>
                            <StyledCategoryHeading
                              onClick={() => {
                                setBlock2(Block2 === 'hospital' ? false : 'hospital');
                                setMobileBlock(MobileBlock === 'hospital' ? false : 'hospital');
                              }}
                            >
                              <StyledCategory>{t('DetailsJob:Hospital')}</StyledCategory>
                              <StyledCaretDown
                                src="../../../../static/images/svg/CaretDown.svg"
                                Block2hide={Block2 === 'hospital'}
                                MobileHide={MobileBlock === 'hospital'}
                              />
                              <StyledCaretUp
                                src="../../../../static/images/svg/CaretUp.svg"
                                Block2hide={Block2 === 'hospital'}
                                MobileHide={MobileBlock === 'hospital'}
                              />
                            </StyledCategoryHeading>
                            <StyledLinks Block2hide={Block2 !== 'hospital'} MobileHide={MobileBlock !== 'hospital'}>
                              {
                                hospitalVariantList.map(variant => (
                                  <StyledVariant>
                                    <Link
                                      passHref
                                      href={DETAILS_TREATMENT}
                                      params={{ slug: variant[0].attributes.slug }}
                                    >
                                      <StyledVariantLink target="_blank">
                                        {variant[0].attributes.name}
                                      </StyledVariantLink>
                                    </Link>
                                  </StyledVariant>
                                ))
                              }
                            </StyledLinks>
                          </StyledCategoryBody>
                        )
                        : <></>}
                      {doctorVariantList.length !== 0
                        ? (
                          <StyledCategoryBody Block2hide={Block2 !== 'doctors'} MobileHide={MobileBlock === 'doctors'}>
                            <StyledCategoryHeading
                              onClick={() => {
                                setBlock2(Block2 === 'doctors' ? false : 'doctors');
                                setMobileBlock(MobileBlock === 'doctors' ? false : 'doctors');
                              }}
                            >
                              <StyledCategory>{t('DetailsJob:Doctor')}</StyledCategory>
                              <StyledCaretDown
                                src="../../../../static/images/svg/CaretDown.svg"
                                Block2hide={Block2 === 'doctors'}
                                MobileHide={MobileBlock === 'doctors'}
                              />
                              <StyledCaretUp
                                src="../../../../static/images/svg/CaretUp.svg"
                                Block2hide={Block2 === 'doctors'}
                                MobileHide={MobileBlock === 'doctors'}
                              />
                            </StyledCategoryHeading>
                            <StyledLinks Block2hide={Block2 !== 'doctors'} MobileHide={MobileBlock !== 'doctors'}>
                              {
                                doctorVariantList.map(variant => (
                                  <StyledVariant>
                                    <Link
                                      passHref
                                      href={DETAILS_TREATMENT}
                                      params={{ slug: variant[0].attributes.slug }}
                                    >
                                      <StyledVariantLink target="_blank">
                                        {variant[0].attributes.name}
                                      </StyledVariantLink>
                                    </Link>
                                  </StyledVariant>
                                ))
                              }
                            </StyledLinks>
                          </StyledCategoryBody>
                        )
                        : <></>}
                    </StyledRealtedPagesDiv>
                  </StyledRelatedPagesDesktop>
                </StyledCoverMaxWidthNoBottomMargin>
              </StyledPageCover>
            )
            : <></>}
          {isPackageRequesting && <Loader />}
          {packages.length > 0 && (
          <StyledCoverMaxWidthNoBottomMargin>
            <StyledPageCover>
              <StyledRelatedPageHeading>
                {t('DetailsJob:PackagesHeadline', {
                  title: isDefault ? title : parent_name || ''
                })}
              </StyledRelatedPageHeading>
            </StyledPageCover>

            {isMobile
              ? (
                <>
                  <ItemsCarousel
                    requestToChangeActive={setPackageSlide}
                    activeItemIndex={packageSlide}
                    numberOfCards={1}
                    gutter={20}
                    alwaysShowChevrons
                    showIndicators
                  >
                    {(packages || []).slice(0, 8).map(object => (
                      <PackageSearchResultListItem
                        key={object.id}
                        size={{
                          mobile: 1
                        }}
                        result={object}
                        facilityPage
                      />
                    ))}
                  </ItemsCarousel>
                  {packages.length > 1 && (
                  <ProgressBar
                    slide={packageSlide}
                    handleTimeInterval={handlePackageTimeInterval}
                    setSlide={setPackageSlide}
                    intervalId={intervalPackageId}
                    clickable
                    color={color}
                    homePage
                    length={(packages || []).slice(0, 8).length}
                    contributionCard
                  />
                  )}
                </>
              )
              : (
                <GridCarousel
                  length={packages.slice(0, 8).length}
                  onScreenCount={onScreenCountPackages}
                  pagination
                  homePage
                  contributionCard
                >
                  <>
                    {(packages || []).slice(0, 8).map(object => (
                      <PackageSearchResultListItem
                        key={object.id}
                        size={{
                          mobile: 1
                         / calculateGridUnitSize(packages.slice(0, 8).length, onScreenCountPackages)
                        }}
                        result={object}
                        facilityPage
                      />
                    ))}
                  </>
                </GridCarousel>
              )}
          </StyledCoverMaxWidthNoBottomMargin>
          )}
          <StyledPageCover>
            <StyledCoverMaxWidthNoBottomMargin>
              {testimonials.length !== 0
                ? (
                  <StyledTestimonials>
                    <StyledRelatedPageHeading>
                      {t('DetailsJob:Testimonial')}
                    </StyledRelatedPageHeading>
                    <StyledTestimonialImages>
                      {testimonials.map(testimonial => (
                        <TestimonialImages
                          src={testimonial.attributes.file.url}
                          alt={testimonial.attributes.name.replace(/\.[^/.]+$/, '')}
                        />
                      ))}
                    </StyledTestimonialImages>
                  </StyledTestimonials>
                ) : <></>}
            </StyledCoverMaxWidthNoBottomMargin>
          </StyledPageCover>

          {isDoctorRequesting && <Loader />}

          {doctors.length > 0 && !isDoctorVariant && (
          <StyledCoverMaxWidthNoBottomMargin>
            <StyledMiniVerticalSpacer />
            <StyledPageCover>
              <MainSubHealine textcolor="rgb(19, 108, 157)">
                {t('DetailsJob:RealtedDoctorHeadline', {
                  title: isDefault ? title : parent_name || ''
                })}
              </MainSubHealine>
            </StyledPageCover>
            {isMobile
              ? (
                <>
                  <ItemsCarousel
                    requestToChangeActive={setDoctorsSlide}
                    activeItemIndex={doctorsSlide}
                    numberOfCards={1}
                    gutter={20}
                    alwaysShowChevrons
                    showIndicators
                  >
                    {(doctors || []).slice(0, 8).map(doctor => (
                      <SearchResultListItem
                        key={`result-list-item-${doctor.id}`}
                        result={doctor}
                        bookConsultation="hide"
                        size={{
                          mobile:
                            1
                        }}
                      />
                    ))}
                  </ItemsCarousel>
                  {doctors.length > 1 && (
                  <ProgressBar
                    slide={doctorsSlide}
                    handleTimeInterval={handleDoctorTimeInterval}
                    setSlide={setDoctorsSlide}
                    intervalId={intervalDoctorId}
                    clickable
                    color={color}
                    homePage
                    length={(doctors || []).slice(0, 8).length}
                    contributionCard
                  />
                  )}
                </>
              )
              : (
                <GridCarousel
                  length={(doctors || []).slice(0, 8).length}
                  onScreenCount={onScreenCount}
                  pagination
                  homePage
                  contributionCard
                >
                  <>
                    {(doctors || []).slice(0, 8).map(doctor => (
                      <SearchResultListItem
                        key={`result-list-item-${doctor.id}`}
                        result={doctor}
                        bookConsultation="hide"
                        size={{
                          mobile:
                          1
                          / calculateGridUnitSize((doctors || []).slice(0, 8).length, onScreenCount)
                        }}
                      />
                    ))}
                  </>
                </GridCarousel>
              )}

            <StyledFlexCenter>
              <Link passHref href={FINDER_DOCTOR}>
                <StyledSeeMore>{t('DetailsJob:SeeAllDoctors')}</StyledSeeMore>
              </Link>
            </StyledFlexCenter>
          </StyledCoverMaxWidthNoBottomMargin>
          )}

          {blogList.length > 0
          && (
          <StyledCardsMaxWidth>
            <StyledPageCover>
              <MainSubHealine textcolor="rgb(19, 108, 157)" center>
                {t('Treatments:Blogs')}
              </MainSubHealine>
            </StyledPageCover>
            <StyledSwiper>
              <Swiper
                className="custom-swiper"
                slidesPerView={isMobile ? 2 : 4}
                spaceBetween={5}
                loop={false}
                pagination={showLoop ? { clickable: true } : false}
                navigation={isMobile ? false : showLoop}
                slidesPerGroup={isMobile ? 2 : 4}
              >
                {(blogList || []).slice(0, 8).map(object => (
                  <SwiperSlide key={object.id}>
                    <ArticleCard
                      key={object.id}
                      size={{
                        mobile:
                          1
                          / calculateGridUnitSize((blogList || [])
                            .slice(0, 8).length, onScreenCount)
                      }}
                      article={object}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </StyledSwiper>
          </StyledCardsMaxWidth>
          )}

          {faqs && faqs.length > 0 && (
          <StyledPageCover style={{ padding: '15px', marginTop: isMobile ? '0rem' : '4rem' }}>
            <StyledCoverMaxWidthNoBottomMargin>
              <StyledVerticalSpacer>
                <FAQQUESTIONEXPAND
                  data={faqs}
                  heading={`FAQs Related to ${isDefault ? title : parent_name || ''}`}
                  treatment
                />
              </StyledVerticalSpacer>
            </StyledCoverMaxWidthNoBottomMargin>
          </StyledPageCover>
          )}
        </LazyLoadOnMobile>
      </>
    </StyledScreenWrapper>
  );
};
export const DocumentForm = ({
  id, setFinish, finish, t
}: any) => (
  <StyledGrid>
    {!finish ? (
      <DocumentsWrapper>
        <StyledVerticalSpacer>
          <DocumentsUploadNew created_patient_id={id} setSuccess={setFinish} treatmentPage />
        </StyledVerticalSpacer>
      </DocumentsWrapper>
    ) : (
      <>
        <StyledGridUnit size={{ mobile: 1 }}>
          <StyledCompletedIcon />
          <StyledMiniVerticalSpacer />
        </StyledGridUnit>
        <ContactImmediatelyHeadline>{t('DetailsJob:ContactNow')}</ContactImmediatelyHeadline>
        <StyledMiniVerticalSpacer />
        <StyledGridUnit size={{ mobile: 1 / 2 }}>
          <a href="tel:+919599818171">
            <StyledMiniPhone />
          </a>
        </StyledGridUnit>
        <StyledGridUnit size={{ mobile: 1 / 2 }}>
          <StyledVerticalSpacer>
            <a href="https://api.whatsapp.com/send?phone=919599818171&text=Hello%20Yapita%20Health.%20I%20need%20medical%20assistance%20for:">
              <StyledMiniWhatsapp />
            </a>
          </StyledVerticalSpacer>
        </StyledGridUnit>
      </>
    )}
  </StyledGrid>
);

export const CostPageForm = ({
  handlePhoneChange, values, errors, handleSubmit, t, phonefunction
}: any) => {
  const {
    first_name, last_name, phone, email
  } = values;
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const [validateMessage, setValidateMessage] = useState(false);

  useEffect(() => {
    if (phonefunction(values.phone).isValid) {
      setValidateMessage(false);
    }
  }, [values.phone]);
  const formJson = t('DetailsJob:Form', { returnObjects: true });
  const withFormId = key => `treatment-page-form-${key}`;
  return (
    <>
      <StyledGrid>
        <StyledFormUnit size={{ mobile: 1 / 2 }}>
          <StyledLabel textcolor="white" htmlFor={withFormId('first_name')}>
            {formJson.FirstName}
          </StyledLabel>
        </StyledFormUnit>
        <StyledFormUnit size={{ mobile: 1 / 2 }} even>
          <StyledLabel textcolor="white" htmlFor={withFormId('last_name')}>
            {formJson.LastName}
          </StyledLabel>
        </StyledFormUnit>
      </StyledGrid>
      <StyledFormRow dmb>
        <StyledFormUnit size={{ mobile: 1 / 2 }} border>
          <StyledFastField
            id={withFormId('first_name')}
            name="first_name"
            component={Input}
            inputComponent={StyledInput}
            greyBlue
            roundedMobile
            border="1px solid #C9D8E8"
          />
        </StyledFormUnit>
        <StyledFormUnit size={{ mobile: 1 / 2 }} even border>
          <StyledFastField
            name="last_name"
            id={withFormId('last_name')}
            component={Input}
            inputComponent={StyledInput}
            greyBlue
            roundedMobile
            border="1px solid #C9D8E8"
          />
        </StyledFormUnit>
      </StyledFormRow>
      <StyledGrid>
        <StyledGridUnit>
          <StyledLabel textcolor="white" htmlFor={withFormId('email')}>
            {formJson.Email}
          </StyledLabel>
        </StyledGridUnit>
      </StyledGrid>
      <StyledFormRow>
        <StyledGridUnit size={{ desktop: 1 }}>
          <StyledFastField
            id={withFormId('email')}
            name="email"
            component={Input}
            inputComponent={StyledInput}
            greyBlue
            roundedMobile
          />
        </StyledGridUnit>
      </StyledFormRow>

      <StyledGrid>
        <StyledGridUnit>
          <StyledLabel htmlFor={withFormId('phone')}>{formJson.Phone}</StyledLabel>
        </StyledGridUnit>
      </StyledGrid>
      <StyledFormRow>
        <StyledGridUnit size={{ desktop: 1 }}>
          <InputPhone
            costpage
            id={withFormId('phone')}
            phoneCode={values.phone_code}
            field={{ value: values.phone }}
            error={errors?.phone}
            onChange={handlePhoneChange}
          />
        </StyledGridUnit>
        <StyledValidationMessage ValidationMessage={validateMessage}>
          {t('Treatments:ValidationMessage')}
        </StyledValidationMessage>
      </StyledFormRow>

      <StyledItem>
        <TermsAndConditionsWrapper>
          <Checkbox
            smallCheck
            checked={checkboxChecked}
            id={withFormId('checkboxTermsAndConditions')}
            onChange={setCheckboxChecked}
            // treatmentFormName={treatmentFormName}
          />
          <StyledLabelTextWrapper>
            <Trans i18nKey="ContactPage:ClickTermsAndConditions" />
          </StyledLabelTextWrapper>
        </TermsAndConditionsWrapper>
      </StyledItem>

      <StyledFormRow>
        <StyledSubmitButton
          disable={!first_name || !last_name
            || !phone || !email
            || !checkboxChecked || !(phone.length > 5)}
          onClick={() => {
            if (phonefunction(values.phone).isValid) {
              handleSubmit();
            } else {
              setValidateMessage(true);
            }
          }}
        >
          {formJson.Submit}
        </StyledSubmitButton>
      </StyledFormRow>
    </>
  );
};

TreatmentDetails.getInitialProps = async ({ query, store }) => {
  store.dispatch(requestTreatmentDetails(query.slug));
  await waitForPageReady(store);
  const { getState } = store;
  const { page } = getState();
  const { treatmentDetails } = getState();
  if (treatmentDetails?.data?.attributes?.category === 'doctors') {
    store.dispatch(requestDoctorList({
      doctor_ids: treatmentDetails?.data?.attributes?.doctor_ids,
      dontScroll: true,
      custom_per_page: 1000
    }));
  }
  if (treatmentDetails?.data?.attributes?.category === 'hospitals') {
    store.dispatch(requestFacilityList({
      facility_ids: treatmentDetails?.data?.attributes?.facility_ids,
      dontScroll: true,
      custom_items_per_page: 1000
    }));
  }
  const { curefyDomain } = page;
  return {
    namespacesRequired: ['DetailsJob', 'Treatments'],
    query,
    curefyDomain
  };
};

const mapStateToProps = ({
  treatmentDetails,
  doctorFinder,
  packageFinder,
  candidateCreate: { created, created_patient_id },
  facilityFinder,
  blogData
}: GlobalState): {} => ({
  treatmentDetails,
  created,
  doctorFinder,
  facilityData: facilityFinder.data || [],
  packages: packageFinder?.data || [],
  isPackageRequesting: packageFinder?.getStatus.requesting,
  blogs: blogData.data,
  created_patient_id,
  initialFormValues: {
    data: {
      attributes: {
        treatment: treatmentDetails?.data?.attributes?.name || ''
      }
    }
  }
});

export default compose(
  withTranslation('DetailsJob', 'Treatments'),
  connect(
    mapStateToProps,
    {
      requestTreatmentDetails,
      resetTreatmentDetails,
      requestDoctorList,
      resetDoctorList,
      requestPackageList,
      createCandidate,
      requestFacilityList,
      requestBlogArticles,
      resetBlogArticles,
      resetFacilityList,
      resetCandidateCreate
    }
  ),
  withFormik({
    formSubmit: true,
    reduxInitialValuesKey: 'initialFormValues',
    fieldNames: [
      'first_name',
      'last_name',
      'email',
      'phone',
      'phone_code',
      'country',
      'notes',
      'treatment'
    ]
  })
)(TreatmentDetails);
